import { FC } from "react";
import styled from "styled-components";
import { ShoppingBag } from "@/assets/Icons/ShoppingBag";
import { LanguageSwitcher } from "./LanguageSwitcher/LanguageSwitcher";
import { Price } from "@/components/Price";
import Flex from "@/shared/globals/UiElements/Flex";
import SearchBar from "./SearchBar/SearchBar";
import { Section } from "@/shared/layout";
import { themeColor } from "@/shared/styles-utils";
import { NavBarProps } from "../../../types";
import AccountButton from "./DesktopAccountButton";
import Logo from "@/templates/default/elements/Logo";
import DesktopMenu from "../../elements/DesktopMenu";

const DesktopNavbar: FC<NavBarProps> = ({
  itemsCount,
  menu,
  itemsTotal,
  toggleSideCart,
}) => {
  return (
    <ShowAboveMobile>
      <Section boxShadow background="white">
        <NavTop justifyContent="space-between" spacing="m">
          <Flex spacing="xxl" alignItems="center">
            <Logo />
            <SearchBar />
          </Flex>
          <Flex spacing="m" alignItems="center">
            <AccountButton />
            <CartButton data-test="button-side-cart" onClick={toggleSideCart}>
              <Price money={itemsTotal} />
              <ShoppingBagWrapper>
                <ShoppingBagCount>{itemsCount}</ShoppingBagCount>
                <ShoppingBag />
              </ShoppingBagWrapper>
            </CartButton>
            <LanguageSwitcher />
          </Flex>
        </NavTop>

        <DesktopMenu items={menu!} />
      </Section>
    </ShowAboveMobile>
  );
};

export default DesktopNavbar;

/**
 *
 * Styles
 *
 */

const ShowAboveMobile = styled.div`
  display: none;
  @media (min-width: 769px) {
    display: block;
  }
`;

const NavTop = styled(Flex)`
  padding: 20px 0;
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.special.border};
`;

const CartButton = styled.button`
  color: ${({ theme }) => theme.brand.default};
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  background: none;
  padding: 0;
  border: none;
  margin: 0;
  line-height: 0;
  cursor: pointer;
  svg {
    margin-inline-end: 10px;
  }
`;

const ShoppingBagWrapper = styled.span`
  position: relative;
`;

const ShoppingBagCount = styled.span`
  background: ${themeColor("primary")}33;
  color: ${themeColor("primary")};
  font-weight: bold;
  width: 20px;
  height: 20px;
  padding: 4px;
  border-radius: 100%;
  min-width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -10px;
  top: 0px;
  transform: translate(12px, -12px);
`;
